import apiHandler from "./apiHandler"

const createIntent = async request => {
  try {
    const response = await apiHandler({
      endpoint2: "/stripe/paymentIntent/create",
      method: "POST",
      options: {
        "x-access-token": localStorage.getItem("token"),
      },
      data: request,
    })

    if (response.response_code == 200) {
      return response.data
    } else {
      throw new Error(response.message || "Failed to create payment intent")
    }
  } catch (error) {
    console.error("Error creating payment intent:", error)
    throw error
  }
}

export default createIntent
